import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Card, Collapse } from "react-bootstrap";
import filterTypes from "data/filter-types";
import findFilterValue from "helpers/find-filter-value";
import searchOperationGenerator from "helpers/search-operation-generator";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";
import withFilters from "views/lib/HOC/withFilters";
import { getFilters } from "actions/chargers/station/actions";
import { getAdminsByRole } from "actions/admin/actions";

class Filers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filters: {},
      ownersList: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);

    this.props.getFilters();
    this.props.getAdminsByRole("ROLE_PARTNER", (response) => {
      this.setState({
        ownersList: response,
      });
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.totalCount !== this.props.totalCount) {
      return true;
    } else if (nextState.isOpen !== this.state.isOpen) {
      return true;
    } else if (!_.isEqual(nextState.filters, this.state.filters)) {
      return true;
    } else if (!_.isEqual(nextProps.activeFilters, this.props.activeFilters)) {
      return true;
    } else if (!_.isEqual(nextProps.filters, this.props.filters)) {
      return true;
    }
    return false;
  }

  handleSearch = () => {
    const { filters } = this.state;
    const filtersToArray = [];
    Object.keys(filters)
      .forEach(name => {
        if (Object.keys(filters[name]).length) {
          filtersToArray.push(filters[name]);
        }
      });
    this.props.handleSearch(filtersToArray);
  };

  handleReset = () => {
    this.props.handleSearch([]);
  };

  handleChangeFilter = (name, valueObject) => {
    const { filters } = this.state;
    filters[name] = valueObject;
    this.setState({
      filters
    });
  };

  handleAdd = () => {
  };

  render() {
    const {
      activeFilters,
      totalCount,
      filters,
    } = this.props;

    const { isOpen } = this.state;

    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title="Stations"
          totalCount={totalCount}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
        />
        <Card.Body className="p-0">
          <Collapse in={isOpen} className="p-3" timeout={0}>
            <div className="row">
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="qr"
                  placeholder="QR"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.qr, [filterTypes.EQUALS.value])}
                  value={findFilterValue("id", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="powerBanks.id"
                  placeholder="PB ID"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.id, [filterTypes.EQUALS.value])}
                  value={findFilterValue("powerBanks.id", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="owners.fullname"
                  placeholder="Owner Full Name"
                  filterType="select"
                  filterTypeOptions={this.state.ownersList.map((item) => ({
                    label: item.name,
                    value: item.name
                  }))}
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.owners, [filterTypes.EQUALS.value])}
                  value={findFilterValue("owners.fullname", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="owners.percent"
                  placeholder="Owner Percent"
                  filterType="number"
                  defaultValue=""
                  onChange={(name, valueObject) => {
                    if (typeof valueObject === "object" && Object.keys(valueObject).length) {
                      this.handleChangeFilter(name, {
                        ...valueObject,
                        fieldValue: parseFloat(valueObject.fieldValue)
                      });
                    } else {
                      this.handleChangeFilter(name, {});
                    }
                  }}
                  searchOperation={searchOperationGenerator(filters.owners, [
                    filterTypes.EQUALS.value,
                    filterTypes.LESS.value,
                    filterTypes.MORE.value
                  ])}
                  value={findFilterValue("owners.percent", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="powerBanksCount"
                  placeholder="PB count"
                  filterType="number"
                  defaultValue=""
                  onChange={(name, valueObject) => {
                    if (typeof valueObject === "object" && Object.keys(valueObject).length) {
                      this.handleChangeFilter(name, {
                        ...valueObject,
                        fieldValue: parseFloat(valueObject.fieldValue)
                      });
                    } else {
                      this.handleChangeFilter(name, {});
                    }
                  }}
                  searchOperation={searchOperationGenerator(filters.powerBanksCount, [filterTypes.EQUALS.value, filterTypes.LESS.value, filterTypes.MORE.value])}
                  value={findFilterValue("powerBanksCount", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="translations.destinationName"
                  placeholder="Name"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.translations, [filterTypes.EQUALS.value, filterTypes.LIKE.value])}
                  value={findFilterValue("translations.destinationName", activeFilters)}
                />
              </div>

              <div className="col-6 col-md-6 mb-6 pb-3">
                <div className="d-flex justify-content-between justify-content-md-end">
                  <button
                    className="btn btn-warning btn-sm ml-2"
                    onClick={this.handleReset}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-success btn-sm ml-2"
                    onClick={this.handleSearch}
                  >
                    Load
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    );
  }
}

Filers.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  filters: state.chargerStation.filters,
});

const mapStateToDispatch = dispatch => ({
  getFilters: bindActionCreators(getFilters, dispatch),
  getAdminsByRole: bindActionCreators(getAdminsByRole, dispatch),
});

export default withFilters(connect(
  mapStateToProps,
  mapStateToDispatch
)(Filers));



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/filters.js